(() => {
  const paths = ['/a/bundles/magic-gift-bundle-izzg','/a/bundles/magic-pant-bundle-izzh','/a/bundles/magic-sweater-bundle-izzj','/a/bundles/magic-pant-&-sweater-bundle-izzi'];
  if (location.pathname.startsWith('/products/')) { initProductDetailPage(paths); return; }
  if (!paths.includes(decodeURI(location.pathname).replace(/\/$/, ''))) return;
  document.documentElement.classList.add('bstore-bundle-page');
  let pending = null, pendingCount = 0, timer = null;
  let restoring = loadRestoration(), activeFlow = null;
  const pair = !location.pathname.includes('magic-gift-bundle-');
  const selectedCount = section => Array.from(document.querySelectorAll('.bndlr-sectioned-status-box-product')).filter(el => el.dataset.sectionId === section.dataset.bundlerSection).reduce((n,el) => n + (parseInt(el.querySelector('.bndlr-sectioned-status-box-product-quantity')?.textContent,10) || 1),0);
  const visible = el => !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  const sections = () => Array.from(document.querySelectorAll('.bndlr-sectioned-section'));
  const moveFocus = el => {
    if (!el) return;
    el.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'start' });
    el.setAttribute('tabindex','-1');
    el.focus({preventScroll:true});
  };
  function readBundleFlow() {
    try { return JSON.parse(sessionStorage.getItem('bstore.bundle.flow.v2') || 'null'); }
    catch (error) { return null; }
  }
  function writeBundleFlow(flow) {
    sessionStorage.setItem('bstore.bundle.flow.v2',JSON.stringify(flow));
  }
  function bundleSelectionSnapshot() {
    return Array.from(document.querySelectorAll('.bndlr-sectioned-status-box-product')).map(item => ({
      section:item.dataset.sectionId,
      variant:item.dataset.variantId,
      quantity:parseInt(item.querySelector('.bndlr-sectioned-status-box-product-quantity')?.textContent,10) || 1
    })).filter(item => item.section && item.variant);
  }
  function openProductDetail(card) {
    const source = card.querySelector('.bndlr-product-title');
    const select = card.querySelector('select.bndlr-select-variant');
    if (!source || !select || restoring) return;
    const url = new URL(source.href,location.origin);
    if (!url.pathname.startsWith('/products/')) return;
    const section = card.closest('.bndlr-sectioned-section');
    const flow = {
      token:crypto.randomUUID(),
      builder:location.pathname,
      productPath:url.pathname,
      name:source.textContent.trim(),
      section:section.dataset.bundlerSection,
      activeSection:section.dataset.bundlerSection,
      selected:select.value,
      complete:section.dataset.requirementsFulfilled === 'true',
      variants:Array.from(select.options).filter(option => option.value).map(option => ({id:option.value,label:option.textContent,disabled:option.disabled})),
      selections:bundleSelectionSnapshot(),
      action:'detail',
      updated:Date.now()
    };
    activeFlow = null;
    try { writeBundleFlow(flow); }
    catch (error) {
      const status = document.querySelector('.bstore-bundle-progress');
      if (status) status.textContent = 'Your browser could not save this bundle. Please choose your item here.';
      return;
    }
    url.searchParams.set('bstore_bundle',flow.token);
    url.searchParams.set('bstore_builder',flow.builder);
    location.assign(location.origin + url.pathname + url.search);
  }
  function createDetailCampaign() {
    const banner = document.createElement('section');
    banner.className = 'bstore-detail-campaign';
    banner.setAttribute('aria-label','Holiday Treasures 2026 gift bundle');
    banner.innerHTML = '<div class="bstore-detail-campaign-copy"><h2>Holiday Treasures 2026</h2><p class="bstore-campaign-tagline">Beautiful gifts. Your way.</p><p>Your selections, presented in a gold gift box.</p></div><div class="bstore-campaign-gift"><div class="bstore-campaign-card" role="img" aria-label="$50 B. Store gift card"><img src="https://www.thebstore.com/cdn/shop/files/mobilepng_42831fea-3276-43b5-ae08-087165466ec4.png?v=1752690247" alt=""><div><span>INCLUDES</span><strong>$50</strong><span>GIFT CARD</span></div></div><p>Includes a <strong>$50 B. Store gift card</strong><br>A little more joy, tucked inside.</p></div>';
    const nav = document.querySelector('.bstore-quick-links');
    if (nav) nav.parentElement.append(banner);
    else document.querySelector('main')?.before(banner);
  }
  function initProductDetailPage(paths) {
    const params = new URLSearchParams(location.search);
    const flow = readBundleFlow();
    const requestedBuilder = params.get('bstore_builder');
    if (!params.get('bstore_bundle') || !paths.includes(requestedBuilder)) return;
    if (!flow || flow.token !== params.get('bstore_bundle') || flow.builder !== requestedBuilder || flow.productPath !== location.pathname) {
      document.documentElement.classList.add('bstore-bundle-detail-page');
      location.replace(requestedBuilder + (flow?.builder === requestedBuilder ? '?bstore_resume=' + encodeURIComponent(flow.token) : ''));
      return;
    }
    document.documentElement.classList.add('bstore-bundle-detail-page');
    let select = null, add = null, navigating = false;
    const returnToBundle = action => {
      if (navigating) return;
      if (action === 'add') {
        const variant = select ? select.value : flow.variants[0]?.id;
        if (!variant) { select?.reportValidity(); return; }
        if (!flow.variants.some(option => option.id === variant && !option.disabled)) return;
        flow.added = {section:flow.section,variant,quantity:1};
      } else delete flow.added;
      flow.action = action;
      flow.updated = Date.now();
      try { writeBundleFlow(flow); }
      catch (error) { return; }
      navigating = true;
      location.assign(flow.builder + '?bstore_resume=' + encodeURIComponent(flow.token));
    };
    const keepBuilding = () => returnToBundle('return');
    const addChoice = () => { if (add && !add.disabled) returnToBundle('add'); };
    window.addEventListener('submit',event => {
      if (!event.target.matches('form[action*="/cart/add"]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addChoice();
    },true);
    window.addEventListener('click',event => {
      if (event.target.closest('[name="add"],[data-js-product-add-to-cart],.shopify-payment-button')) {
        event.preventDefault();event.stopImmediatePropagation();addChoice();return;
      }
      const link = event.target.closest('a');
      if (link && (/^(back to shopping|continue shopping|view all colors)$/i.test(link.textContent.trim()) || /\/(cart|checkout)(\/|\?|$)/.test(link.getAttribute('href') || ''))) {
        event.preventDefault();event.stopImmediatePropagation();keepBuilding();
      }
    },true);
    const install = () => {
      const form = document.querySelector('form[data-type="add-to-cart-form"]');
      if (!form || document.querySelector('.bstore-detail-choice')) return;
      const bar = document.createElement('div');
      bar.className = 'bstore-detail-page-bar';
      const label = document.createElement('strong');
      label.textContent = 'Building your holiday gift bundle';
      const back = document.createElement('button');
      back.type = 'button';
      back.textContent = 'I want to choose a different item';
      back.addEventListener('click',keepBuilding);
      bar.append(label,back);
      document.body.prepend(bar);
      createDetailCampaign();
      const choice = document.createElement('div');
      choice.className = 'bstore-detail-choice';
      const note = document.createElement('p');
      const alreadyAdded = flow.action === 'done' && !!flow.added;
      note.textContent = flow.complete || alreadyAdded ? 'Your choices for this step are saved. Choose a different item to return to your bundle, then use Edit to change a selection.' : 'Choose this piece for your gift bundle. Your other selections are saved.';
      choice.append(note);
      if (flow.variants.length > 1) {
        const sizeLabel = document.createElement('label');
        sizeLabel.htmlFor = 'bstore-detail-size';
        sizeLabel.textContent = 'Choose your size';
        select = document.createElement('select');
        select.id = 'bstore-detail-size';
        select.required = true;
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'Select a size';
        placeholder.disabled = true;
        select.append(placeholder);
        flow.variants.forEach(variant => {
          const option = document.createElement('option');
          option.value = variant.id;option.textContent = variant.label;option.disabled = variant.disabled;
          select.append(option);
        });
        select.value = flow.selected || '';
        choice.append(sizeLabel,select);
      } else {
        const size = document.createElement('p');
        const name = flow.variants[0]?.label || 'As shown';
        size.textContent = 'Size: ' + (/^o\/?s$|one size/i.test(name) ? 'One size' : name);
        choice.append(size);
      }
      form.before(choice);
      add = document.createElement('button');
      add.type = 'button';
      add.className = 'button button--solid bstore-detail-add';
      add.textContent = 'Add this item to my gift bundle';
      add.disabled = flow.complete || alreadyAdded || !flow.variants.some(variant => !variant.disabled);
      add.addEventListener('click',addChoice);
      form.append(add);
      Array.from(document.querySelectorAll('main a')).filter(link => /^(back to shopping|continue shopping)$/i.test(link.textContent.trim())).forEach(link => {
        link.textContent = 'I want to choose a different item';link.href = flow.builder;
        link.addEventListener('click',event => {event.preventDefault();keepBuilding();});
      });
    };
    window.addEventListener('pageshow',event => {
      if (!event.persisted) return;
      navigating = false;
      const saved = readBundleFlow();
      if (saved?.token === flow.token) {
        Object.assign(flow,saved);
        if (add) add.disabled = flow.complete || (flow.action === 'done' && !!flow.added);
      }
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',install,{once:true});
    else install();
  }
  function loadRestoration() {
    const flow = readBundleFlow();
    const resume = new URLSearchParams(location.search).get('bstore_resume');
    if (!flow || flow.builder !== location.pathname || (resume !== flow.token && flow.action !== 'detail')) return null;
    const targets = new Map();
    const items = [...flow.selections];
    if (flow.action === 'add' && flow.added) items.push(flow.added);
    items.forEach(item => {
      const key = item.section + ':' + item.variant;
      const entry = targets.get(key) || {...item,quantity:0};
      entry.quantity += item.quantity || 1;
      targets.set(key,entry);
    });
    return {flow,action:flow.action,targets:Array.from(targets.values()),waiting:null,attempts:0,failed:false};
  }
  function showBundleSection(section) {
    if (visible(section)) return;
    const heading = section.querySelector('.bndlr-section-main-title')?.textContent.trim();
    const status = Array.from(document.querySelectorAll('.bndlr-sectioned-section-name')).find(button => button.querySelector('.bndlr-section-name-text')?.textContent.trim() === heading);
    status?.click();
  }
  function restoreBundleChoices() {
    const steps = sections();
    if (!steps.length) return;
    const counts = new Map();
    bundleSelectionSnapshot().forEach(item => counts.set(item.section + ':' + item.variant,(counts.get(item.section + ':' + item.variant) || 0) + item.quantity));
    if (restoring.waiting) {
      const wait = restoring.waiting;
      if ((counts.get(wait.key) || 0) <= wait.before) {
        if (++restoring.attempts < 100) { schedule();return; }
        restoring.failed = true;
        restoring.targets = restoring.targets.filter(item => item.section + ':' + item.variant !== wait.key);
      }
      restoring.waiting = null;
      restoring.attempts = 0;
    }
    for (const target of restoring.targets) {
      const key = target.section + ':' + target.variant;
      const count = counts.get(key) || 0;
      if (count >= target.quantity) continue;
      const section = steps.find(step => step.dataset.bundlerSection === target.section);
      const option = section && Array.from(section.querySelectorAll('.bndlr-select-variant option')).find(option => option.value === target.variant && !option.disabled);
      if (!section || !option || section.dataset.requirementsFulfilled === 'true') {
        target.quantity = count;restoring.failed = true;continue;
      }
      if (!visible(section)) { showBundleSection(section);schedule();return; }
      const select = option.parentElement;
      const button = select.closest('.bndlr-product').querySelector('.bndlr-add-to-sectioned-bundle');
      if (!visible(button)) { target.quantity = count;restoring.failed = true;continue; }
      select.value = target.variant;
      select.dispatchEvent(new Event('change',{bubbles:true}));
      restoring.waiting = {key,before:count};
      button.click();schedule();return;
    }
    const state = restoring;
    const previous = steps.find(step => step.dataset.bundlerSection === state.flow.activeSection);
    let destination = previous;
    if (state.action === 'add' && previous?.dataset.requirementsFulfilled === 'true') {
      destination = steps.slice(steps.indexOf(previous)+1).find(step => step.dataset.requirementsFulfilled !== 'true') || steps.find(step => step.dataset.requirementsFulfilled !== 'true');
    }
    if (destination) showBundleSection(destination);
    activeFlow = state.flow;
    activeFlow.action = 'done';
    activeFlow.selections = bundleSelectionSnapshot();
    activeFlow.activeSection = destination?.dataset.bundlerSection || previous?.dataset.bundlerSection;
    restoring = null;pending = null;
    try { writeBundleFlow(activeFlow); } catch (error) {}
    updateGuide();
    if (state.failed) document.querySelector('.bstore-bundle-progress').textContent = 'Your available selections are saved. Please choose a replacement for an item that is no longer available.';
    moveFocus(destination?.querySelector('.bndlr-section-main-title') || document.querySelector('.bndlr-sections-status-container'));
  }

  function updateControls() {
    document.querySelectorAll('.bndlr-product').forEach(card => {
      if (card.dataset.productId === '5159843070086') {
        card.remove();
        return;
      }
      if (!card.querySelector('.bstore-see-detail')) {
        const source = card.querySelector('.bndlr-product-title');
        if (source) {
          const link = document.createElement('a');
          link.href = source.href;
          link.className = 'bstore-see-detail';
          link.textContent = 'See product and fit details';
          link.setAttribute('aria-label','See product and fit details about ' + source.textContent.trim());
          source.closest('.bndlr-product-qn-container').after(link);
        }
      }
      const select = card.querySelector('select.bndlr-select-variant');
      if (select && Array.from(select.options).filter(o => o.value).length > 1) {
        if (!select.dataset.bstoreSizeReady) {
          select.dataset.bstoreSizeReady = 'true';
          const section = card.closest('.bndlr-sectioned-section');
          select.id = 'bstore-size-' + (section?.dataset.bundlerSection || '0') + '-' + card.dataset.productId;
          const label = document.createElement('label');
          label.className = 'bstore-bundle-size-label';
          label.htmlFor = select.id;
          label.textContent = 'Choose your size';
          select.before(label);
          const option = document.createElement('option');
          option.value = '';
          option.textContent = 'Select a size';
          option.disabled = true;
          option.selected = true;
          select.prepend(option);
          select.value = '';
          select.required = true;
          select.setAttribute('aria-required','true');
          select.setAttribute('aria-label','Choose your size for ' + (card.querySelector('.bndlr-product-title')?.textContent || 'this color'));
        }
      }
      const button = card.querySelector('.bndlr-add-to-sectioned-bundle');
      if (button && !button.querySelector('img,svg') && button.textContent.trim() !== 'Choose this color') {
        button.textContent = 'Choose this color';
        button.title = 'Choose this color';
      }
    });
  }
  function missingSize(button) {
    const select = button.closest('.bndlr-product')?.querySelector('select[data-bstore-size-ready]');
    return select && !select.value ? select : null;
  }
  function updateSummaries() {
    document.querySelectorAll('.bndlr-sectioned-status-box-product').forEach(item => {
      const image = item.querySelector('.bndlr-sectioned-status-box-product-image');
      const full = image?.getAttribute('title') || image?.getAttribute('alt') || '';
      if (!full || item.dataset.bstoreSummaryTitle === full) return;
      item.dataset.bstoreSummaryTitle = full;
      item.querySelector('.bstore-selected-details')?.remove();
      const split = full.lastIndexOf(' - ');
      const name = split >= 0 ? full.slice(0,split) : full;
      const size = split >= 0 ? full.slice(split + 3) : '';
      const magic = /^(Magic Pant|Magic Sweater)\s+/i.exec(name);
      const details = document.createElement('div');
      details.className = 'bstore-selected-details';
      const title = document.createElement('strong');
      title.textContent = magic ? magic[1] : name;
      details.append(title);
      if (magic) {
        const color = document.createElement('span');
        color.textContent = 'Color: ' + name.slice(magic[0].length).replace(/-?\s*New!$/i,'').trim();
        details.append(color);
      }
      if (size) {
        const sizeLine = document.createElement('span');
        sizeLine.textContent = 'Size: ' + (['O/S','OS','ONE SIZE'].includes(size.toUpperCase()) ? 'One size' : size);
        details.append(sizeLine);
      }
      const edit = document.createElement('button');
      edit.type = 'button';
      edit.className = 'bstore-edit-choice';
      edit.textContent = 'Edit';
      edit.setAttribute('aria-label','Edit ' + name);
      details.append(edit);
      item.append(details);
    });
  }
  function updateBundleValue() {
    const container = document.querySelector('.bndlr-sections-status-container');
    if (!container) return;
    const cartButton = container.querySelector('.bndlr-add-sectioned-bundle-to-cart');
    if (!cartButton) return;
    let gift = container.querySelector('.bstore-included-gift-card');
    if (!gift) {
      gift = document.createElement('div');
      gift.className = 'bstore-included-gift-card';
      gift.setAttribute('role','group');
      gift.setAttribute('aria-label','Included $50 B. Store gift card');
      const image = document.createElement('div');
      image.className = 'bstore-card-art';
      image.setAttribute('role','img');
      image.setAttribute('aria-label','$50 B. Store gift card');
      const logo = document.createElement('img');
      logo.src = 'https://www.thebstore.com/cdn/shop/files/mobilepng_42831fea-3276-43b5-ae08-087165466ec4.png?v=1752690247';
      logo.alt = '';
      const amount = document.createElement('div');
      amount.className = 'bstore-card-amount';
      amount.innerHTML = '<span>INCLUDES</span><strong>$50</strong><span>GIFT CARD</span>';
      image.append(logo,amount);
      const detail = document.createElement('div');
      detail.innerHTML = '<strong>$50 B. Store gift card</strong><span>Included with your bundle</span>';
      gift.append(image,detail);
      const price = container.querySelector('.bndlr-sectioned-total-price');
      (price || cartButton).before(gift);
    }
    let panel = container.querySelector('.bstore-bundle-value');
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'bstore-bundle-value';
      panel.setAttribute('aria-live','polite');
      cartButton.before(panel);
    }
    const total = container.querySelector('.bndlr-sectioned-total-price');
    const original = Number(total?.querySelector('.bndlr-old-price')?.getAttribute('data-currentprice'));
    const price = Number(total?.querySelector('.bndlr-new-price')?.getAttribute('data-currentprice'));
    const ready = sections().length > 0 && sections().every(section => section.dataset.requirementsFulfilled === 'true');
    const money = cents => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(cents / 100);
    let html = '';
    if (ready && Number.isFinite(original) && Number.isFinite(price) && original > price && price > 0) {
      html = '<div class="bstore-value-row"><strong>You save ' + money(original - price) + ' on this bundle.</strong></div>';
    }
    html += '<p class="bstore-value-note"><strong>The joy of giving keeps on giving.</strong><br>Your gift box also includes a <strong>$50 B. Store gift card</strong>, inviting your special someone to discover a little more magic of their own.</p>';
    if (panel.innerHTML !== html) panel.innerHTML = html;
  }
  function updateGuide() {
    updateBundleValue();
    updateControls();
    updateSummaries();
    const steps = sections();
    if (!steps.length) return;
    let guide = document.querySelector('.bstore-bundle-guide');
    if (!guide) {
      guide = document.createElement('div');
      guide.className = 'bstore-bundle-guide';
      guide.innerHTML = '<p class="bstore-bundle-progress" role="status" aria-live="polite"></p><p>Choose your color and available size, then select Choose this color. We will take you to the next choice.</p><p><strong>Includes a $50 B. Store gift card, packed in your gold gift box.</strong></p>';
      steps[0].parentElement.before(guide);
    }
    const active = steps.find(s => visible(s));
    const index = Math.max(0,steps.indexOf(active));
    const allDone = steps.every(s => s.dataset.requirementsFulfilled === 'true');
    const chosen = active ? selectedCount(active) : 0;
    const total = steps.length * (pair ? 2 : 1);
    const current = pair ? index * 2 + Math.min(chosen + 1,2) : index + 1;
    const heading = active?.querySelector('.bndlr-section-main-title')?.textContent || 'Choose your piece';
    const label = pair && chosen === 1 ? 'Choose your second ' + (/sweater/i.test(heading) ? 'Magic Sweater' : 'Magic Pant') + ' — matching or different.' : heading;
    const text = restoring ? 'Restoring your gift bundle…' : allDone ? 'Your bundle is ready. Review your choices below.' : 'Step ' + current + ' of ' + total + ': ' + label;
    const status = guide.querySelector('.bstore-bundle-progress');
    if (status.textContent !== text) status.textContent = text;
    if (activeFlow && !restoring) {
      activeFlow.selections = bundleSelectionSnapshot();
      activeFlow.activeSection = active?.dataset.bundlerSection;
      activeFlow.updated = Date.now();
      try { writeBundleFlow(activeFlow); } catch (error) {}
    }
  }
  function advance() {
    timer = null;
    updateGuide();
    if (restoring) { restoreBundleChoices(); return; }
    if (!pending || !pending.isConnected) return;
    if (pending.dataset.requirementsFulfilled !== 'true') {
      if (selectedCount(pending) > pendingCount) {
        moveFocus(pending.querySelector('.bndlr-section-main-title'));
        pending = null;
      }
      return;
    }
    const completed = pending;
    pending = null;
    const next = completed.querySelector('.bndlr-next-section');
    if (visible(next)) {
      next.click();
      requestAnimationFrame(() => {
        const active = sections().find(s => s !== completed && visible(s));
        if (active?.dataset.requirementsFulfilled === 'true') { pending = active; pendingCount = selectedCount(active); schedule(); }
        else moveFocus(active?.querySelector('.bndlr-section-main-title'));
        updateGuide();
      });
    } else if (sections().every(s => s.dataset.requirementsFulfilled === 'true')) {
      moveFocus(document.querySelector('.bndlr-sections-status-container'));
    }
  }
  const schedule = () => { if (!timer) timer = setTimeout(advance,80); };
  document.addEventListener('click', event => {
    const detail = event.target.closest('.bstore-see-detail');
    if (detail) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openProductDetail(detail.closest('.bndlr-product'),detail);
      return;
    }
    const edit = event.target.closest('.bstore-edit-choice');
    if (edit) {
      event.preventDefault();
      event.stopImmediatePropagation();
      pending = null;
      const item = edit.closest('.bndlr-sectioned-status-box-product');
      const sectionId = item.dataset.sectionId;
      const status = item.closest('.bndlr-sectioned-section-status');
      item.querySelector('.bndlr-close')?.click();
      status?.querySelector('.bndlr-sectioned-section-name')?.click();
      setTimeout(() => {
        const section = sections().find(s => s.dataset.bundlerSection === sectionId);
        moveFocus(section?.querySelector('.bndlr-section-main-title'));
        updateGuide();
      },100);
      return;
    }
    const add = event.target.closest('.bndlr-add-to-sectioned-bundle');
    if (add) {
      const size = missingSize(add);
      if (size) {
        event.preventDefault();
        event.stopImmediatePropagation();
        size.setAttribute('aria-invalid','true');
        size.focus();
        size.reportValidity();
        return;
      }
      if (restoring) return;
      pending = add.closest('.bndlr-sectioned-section'); pendingCount = selectedCount(pending); schedule(); return; }
    const link = event.target.closest('.bndlr-product-image-url,.bndlr-product-title,.bndlr-status-box-product-url');
    if (!link) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const card = link.closest('.bndlr-product');
    if (!card) return;
    const section = card.closest('.bndlr-sectioned-section');
    if (section?.dataset.requirementsFulfilled === 'true') return;
    const select = card.querySelector('select');
    const button = card.querySelector('.bndlr-add-to-sectioned-bundle');
    if (visible(select) && select.options.length > 1) {
      select.focus();
    } else if (visible(button)) {
      button.click();
    }
  },true);
  document.addEventListener('keydown', event => {
    const add = event.target.closest('.bndlr-add-to-sectioned-bundle');
    if (!add || !['Enter',' '].includes(event.key)) return;
    const size = missingSize(add);
    if (!size) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    size.setAttribute('aria-invalid','true');
    size.focus();
    size.reportValidity();
  },true);
  document.addEventListener('change', event => {
    if (event.target.matches('select[data-bstore-size-ready]')) event.target.removeAttribute('aria-invalid');
  });
  window.addEventListener('pageshow',event => {
    if (event.persisted) { restoring = loadRestoration(); schedule(); }
  });
  new MutationObserver(schedule).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['data-requirements-fulfilled','class','style']});
  schedule();
})();